module.exports = __webpack_public_path__ + "static/banner-d6d85cea0425f95fcbbed39fa15f732e.jpg";